import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
let isRedirectingToLogin = false;
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  failedQueue = [];
};

const api = axios.create({
  baseURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401) {
      const url = originalRequest?.url || '';
      const isAuthRoute = url.includes('/auth/login');
      const isRefreshRoute = url.includes('/auth/refresh');
      const isPontoManual = url.includes('/ponto/manual');

      if (isAuthRoute || isRefreshRoute || isPontoManual) {
        return Promise.reject(error);
      }

      if (isRedirectingToLogin) {
        return Promise.reject(error);
      }

      if (!originalRequest._retry) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          }).then((newToken) => {
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return api(originalRequest);
          });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        const oldToken = localStorage.getItem('token');

        return axios.post(`${baseURL}/auth/refresh`, {}, {
          headers: { Authorization: `Bearer ${oldToken}` },
        }).then((response) => {
           const newToken = response.data.token;
           localStorage.setItem('token', newToken);
           if (response.data.user) {
             localStorage.setItem('user', JSON.stringify(response.data.user));
             window.dispatchEvent(new Event('auth:user-updated'));
           }
          api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
          processQueue(null, newToken);

          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        }).catch((refreshError) => {
          processQueue(refreshError, null);
          isRedirectingToLogin = true;
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }).finally(() => {
          isRefreshing = false;
        });
      }
    }

    return Promise.reject(error);
  }
);

export default api;
